module.exports = {
      id: "search-white-usage",
      viewBox: "0 0 20 20.051",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#search-white",
      toString: function () {
        return this.url;
      }
    }